import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function slugify(text: string): string {
    const turkishChars: { [key: string]: string } = {
        'ğ': 'g', 'Ğ': 'g',
        'ü': 'u', 'Ü': 'u',
        'ş': 's', 'Ş': 's',
        'ı': 'i', 'İ': 'i',
        'ö': 'o', 'Ö': 'o',
        'ç': 'c', 'Ç': 'c',
        'û': 'u', 'Û': 'u',
        'î': 'i', 'Î': 'i',
        'â': 'a', 'Â': 'a',
        'I': 'i'
    };

    return text
        .replace(/[ğĞüÜşŞıİöÖçÇûÛîÎâÂI]/g, letter => turkishChars[letter])
        .toLowerCase()
        .trim()
        .replace(/[^a-z0-9\s-]/g, '')

        .replace(/\s+/g, '-')
        .replace(/-+/g, '-');
}
